var _a;
import { createCustomAction, EActionState } from "../utils/action.utils";
import { GENERATOR_PARAMS } from "./system.constants";
var EActionCustom;
(function (EActionCustom) {
    EActionCustom["Search"] = "SEARCH";
})(EActionCustom || (EActionCustom = {}));
var generateSearchActions = function () { return ({
    getSearchStart: createCustomAction({
        entity: GENERATOR_PARAMS.entity,
        custom: EActionCustom.Search,
        state: EActionState.Start,
    }),
    getSearchSucceeded: createCustomAction({
        entity: GENERATOR_PARAMS.entity,
        custom: EActionCustom.Search,
        state: EActionState.Success,
    }),
    getSearchFailed: createCustomAction({
        entity: GENERATOR_PARAMS.entity,
        custom: EActionCustom.Search,
        state: EActionState.Fail,
    }),
}); };
export var getSearchStart = (_a = generateSearchActions(), _a.getSearchStart), getSearchSucceeded = _a.getSearchSucceeded, getSearchFailed = _a.getSearchFailed;
